export default __webpack_public_path__ + "static/media/Vodka.148eb91a.mp3";